// 计费单

import { HttpGetInventoryList, HttpGetInventoryListExport,HttpGetProduct } from '@/service/inventory';
import TableList from "@components/templates/tablelist";
import comExcel from '@components/templates/excelalert';
import mixin from "../mixin.js";
import { mapGetters } from 'vuex';
import comIndex from './update'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            exportData: {},
            products:[],
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    components: {
        comIndex,
        comExcel
    },
    watch:{
        "$route":function (to,from) {
            this.$set(this.formData,"search[EQ_organizationId]",this.isAdmin() ? '' : global.SYSID)
            this.updateList();
        }
    },
    methods: {
        ajaxRequest: HttpGetInventoryList,
        interceptResponse(params){
            if(params.content.length>0){
                let productIds = [];
                params.content.forEach(item => {
                    productIds.push(item.productId);
                  });
                HttpGetProduct({
                    contextId: global.SYSID,
                    productIds:productIds
                  })
                    .then(res => {
                        this.products = res.data;
                    })
                    .catch(err => {
                      this.$VMessage.error(err.message);
                    });
            }

        },
        interceptRequest(params) {
            const search = params.search
            // params.search.EQ_organizationId = this.isAdmin() ? '' : global.SYSID;
            params.state = this.isAdmin() ? '1' : '0';
            params.search.IN_warehouseType = this.isAdmin() ? '1,4,5,6' : '1,2,4,5,6';
            this.formData.state = params.state;
            if(params.search.isFilter){
                params.search.NE_inventoryAvailable = 0
            }
            delete params.search.isFilter
            this.exportData = params;
            if (this.$route.query.erpsku) {
                search.RCN_sku = this.$route.query.erpsku
                delete params.search.BT_updatedAt;
                // console.log(params)
                return params
            } else {
                return params
            }
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpGetInventoryListExport, this.exportData, {
                        executor: "request",
                        download: true
                    }).then(res => {
                        this.operate = {
                            title: this.$t('global.common.export', { defaultValue: '导出' }),
                            show: true,
                            width: 560,
                            component: "comExcel",
                            showFooter: false
                        }
                    });
                    break;
                case "query":
                    {
                        this.operate = {
                            title: '查看',
                            show: true,
                            width: 1200,
                            component: "comIndex",
                            detaildatas: params,
                            isAdminnum:this.isAdmin(),
                            querytype: 'query',
                            showFooter: false
                        }
                    }

                    break;
            }
        },
        isAdmin() {
            return this.$route.name === 'inventorySerList';
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getProductList','getSelfmanageorgList', 'getBillcusorgList', 'getCusproductList', 'getSystemWareList','getAdminTransferWarehouse', 'getTransferWarehouse', 'getTransferWarehouse', 'getAdminTransferWarehouse']),
        // ...mapGetters('common', ['getInventoryType', 'getProductType']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.export', { defaultValue: "导出" }),
                    show: this.handleAuth('fbb.reportinwentoryDetail.export'),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    key: 'IN_organizationId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    hidden: !this.isAdmin(),
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                },
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: this.isAdmin() ? 'IN_orgWarehouseCode' : 'IN_orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'IN_groupCode',
                    more: true,
                    tag: 'vSelect',
                    options: this.isAdmin() ? this.getCusproductList : this.getProductList,
                    props: {
                        filterable: true,
                        multiple: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "SKU",
                    key: 'RCN_sku',
                    show: true,
                    default: this.$route.query.erpsku,
                    tag: 'vInput',
                },
                {
                    label: this.$t('erp.setting.goods_type', { defaultValue: "产品类型" }),
                    key: 'EQ_productType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getProductType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key: 'EQ_inventoryType',
                    more: true,
                    tag: 'vSelect',
                    options: this.getInventoryType,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    show: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
                {
                    label: "",
                    tag: 'Checkbox',
                    key: 'isFilter',
                    show: true,
                    children:(h)=>{
                        return <span >{this.$t('fbb.inventory.filter_SKU', { defaultValue: "过滤零库存SKU" })}</span>
                    },
                    style: "width:120px;font-size:12px",
                    remark: this.$t('fbb.inventory.filter_SKU', { defaultValue: "过滤零库存SKU" }),
                },
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户' }),
                    key: 'organizationId',
                    width: this.isAdmin() ? 100 : 0,
                    render: (h, { row }) => {
                        let orgName = this.getSelfmanageorgList.filter(item => {
                            return item.value === row.organizationId
                        })[0] || {}
                        return orgName.label
                    }
                },
                {
                    title: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' }),
                    width: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.isAdmin() ? this.getAdminTransferWarehouse : this.getTransferWarehouse).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineName',
                },
                {
                    title: 'SKU',
                    key: 'sku',
                },
                {
                    title:this.$t('fbb.inventory.SKU_chinese', { defaultValue: 'SKU中文品名' }) ,
                    key: 'productName',
                },
                {
                    title: this.$t('erp.setting.goods_type', { defaultValue: '产品类型' }),
                    width: 80,
                    render: (h, { row }) => {
                        let productType = row.productType
                        const { label } = this.getProductType.find(function (item) {
                            return item.value == productType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: '库存类型' }),
                    width: 80,
                    render: (h, { row }) => {
                        let inventoryType = row.inventoryType
                        const { label } = this.getInventoryType.find(function (item) {
                            return item.value == inventoryType
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: this.$t('erp.product.available', { defaultValue: '可用' }),
                    key: 'inventoryAvailable',
                    sortable: true
                },
                {
                    title: this.$t('erp.product.reserved', { defaultValue: '预留' }),
                    key: 'inventoryReserved',
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>
                            <a onClick={this.handleOperates.bind(this, {sku:row.sku,orgWarehouseId:row.orgWarehouseId,orgWarehouseCode:row.orgWarehouseCode,warehouseId:row.warehouseId,inventoryType:row.inventoryType,productId:row.productId,chosetype:'yuliu'}, 'query')}>{row.inventoryReserved}</a>
                        </div>
                    }
                },
                {
                    title: this.$t('erp.product.transport', { defaultValue: '在途' }),
                    key: 'inventoryTransport',
                    sortable: true,
                    render:(h,{row})=>{
                        return <div>
                            <a onClick={this.handleOperates.bind(this, {sku:row.sku,orgWarehouseId:row.orgWarehouseId,orgWarehouseCode:row.orgWarehouseCode,warehouseId:row.warehouseId,inventoryType:row.inventoryType,productId:row.productId,chosetype:'zaitu'}, 'query')}>{row.inventoryTransport}</a>
                        </div>
                    }
                },
                {
                    title: this.$t('erp.product.current', { defaultValue: '总库存' }),
                    key: 'inventoryCurrent',
                    sortable: true
                },
                // {
                //     title: this.$t('fbb.inventory.product_value', { defaultValue: '产品价值' }),
                //     key: 'fobCost',

                // },
                // {
                //     title: this.$t('erp.product_channel.currency', { defaultValue: '币种' }),
                //     key: 'inventoryCurrency',
                // },
                {
                    title: `${this.$t('fbb.accountmanage.material_size_length', { defaultValue: '长' })}*${this.$t('fbb.accountmanage.material_size_width', { defaultValue: '宽' })}*${this.$t('fbb.accountmanage.material_size_height', { defaultValue: '高' })}(cm)`,
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var Length = product.length;
                            var Width =  product.width;
                            var Height =  product.height;
                            return <div>{Length}*{Width}*{Height}</div>
                          }

                    }
                },
                {
                    title: this.$t('global.common.weight(g)', { defaultValue: '重量(g)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        var product = this.products.filter(
                            item => {
                              return item.id == row.productId;
                            }
                          )[0]
                          if(product){
                            var weight2 = product.weight
                            return <div>{weight2}</div>
                          }


                    }
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    width: 150,
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
        },
    },
};




